"use strict";
// Copyright © Veeam Software Group GmbH
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WidgetSpinner = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const components_1 = require("@veeam/components");
const constants_1 = require("../../constants");
const Root = styled_components_1.default.div `
  position: relative;
  width: 100%;
  height: 100%;
`;
exports.WidgetSpinner = react_1.default.memo(() => {
    return (react_1.default.createElement(Root, null,
        react_1.default.createElement(components_1.Overlay, { view: components_1.OVERLAY_VIEW.ghost, contentMod: components_1.OVERLAY_CONTENT_MOD.center },
            react_1.default.createElement(components_1.Spinner, { size: constants_1.SPINNER_SIZES.xxl }))));
});
//# sourceMappingURL=WidgetSpinner.js.map